var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "51.000000pt",
    height: "51.000000pt",
    viewBox: "0 0 51.000000 51.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,51.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226 484 c-31 -31 -6 -99 32 -87 15 4 15 3 2 -6 -13 -9 -12 -11 5 -11 31 0 45 19 45 62 0 53 -49 78 -84 42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 372 c-25 -17 -43 -130 -24 -159 7 -10 21 -15 89 -29 14 -2 25 -16 33 -38 15 -47 36 -64 55 -45 11 12 10 22 -9 69 -21 51 -25 55 -64 63 -34 7 -42 12 -42 30 0 12 -9 33 -20 47 -33 43 -22 43 18 0 22 -22 46 -40 55 -40 8 0 17 -6 20 -12 3 -10 9 -9 22 4 21 20 12 38 -20 38 -13 0 -37 12 -52 26 -15 14 -22 23 -15 19 15 -8 16 7 0 23 -14 14 -28 15 -46 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 343 c-4 -3 -7 -15 -7 -25 0 -15 8 -18 56 -18 l55 0 -3 -32 -3 -33 -53 2 c-48 2 -53 1 -50 -18 2 -11 6 -20 11 -19 4 0 36 0 72 0 l65 0 0 75 0 75 -68 0 c-38 0 -72 -3 -75 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 284 c-9 -11 -10 -20 -3 -32 20 -30 34 -25 34 12 0 39 -10 45 -31 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 264 c-3 -3 5 -33 18 -67 18 -49 27 -61 42 -59 39 8 65 3 84 -14 10 -9 19 -12 19 -6 0 15 -40 42 -62 42 -9 0 -20 9 -23 20 -4 11 -17 28 -31 36 -13 9 -24 22 -24 30 0 15 -14 26 -23 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 148 c0 -18 -3 -45 -7 -60 -12 -42 17 -36 32 6 25 70 116 69 137 -1 l9 -33 78 0 c45 0 78 4 78 10 0 6 -28 10 -64 10 -37 0 -68 5 -72 11 -4 6 -7 29 -7 50 l0 39 -93 0 -93 0 2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 112 c-22 -24 -21 -65 1 -85 32 -29 78 -19 93 20 22 59 -53 111 -94 65z m61 -35 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 110 c-11 -11 -20 -29 -20 -40 0 -27 35 -60 63 -60 50 0 76 70 39 103 -25 23 -58 21 -82 -3z m60 -25 c15 -18 5 -35 -21 -35 -12 0 -19 7 -19 18 0 33 20 42 40 17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.893b950297893317ec5f0c2b19d706d0.svg";
export { ForwardRef as ReactComponent };